import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, onSnapshot, deleteDoc, doc, query, orderBy } from 'firebase/firestore';

function SchedulesPage() {
  const [schedules, setSchedules] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const rotasRef = collection(db, 'rotas');
    const q = query(rotasRef, orderBy('createdAt', 'desc')); // Sort by createdAt in descending order
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const schedulesArray = snapshot.docs.map(doc => {
        const data = doc.data();
        if (data.rota) {
          Object.keys(data.rota).forEach(eventKey => {
            if (!data.rota[eventKey]['Socmed']) {
              data.rota[eventKey]['Socmed'] = 'Unassigned';
            }
          });
        }
        return {
          id: doc.id,
          ...data
        };
      });
      setSchedules(schedulesArray);
    }, (error) => {
      console.error("Error fetching schedules:", error);
    });

    return () => unsubscribe();
  }, []);

  const handleViewRota = (scheduleId) => {
    navigate(`/view-rota/${scheduleId}`);
  };

  const handleDeleteRota = (scheduleId) => {
    setConfirmDelete(scheduleId);
  };

  const confirmDeleteRota = async () => {
    if (confirmDelete) {
      try {
        const rotaRef = doc(db, 'rotas', confirmDelete);
        await deleteDoc(rotaRef);
        setConfirmDelete(null);
      } catch (error) {
        console.error('Error deleting rota:', error);
        alert('Failed to delete rota. Please try again.');
      }
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="page-container">
      <h1 className="text-3xl font-bold text-gray-800 text-center mb-8">Saved Schedules</h1>
      
      {schedules.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-gray-500 text-lg mb-6">No schedules saved yet.</p>
          <button 
            onClick={() => navigate('/create-rota')}
            className="btn-primary"
          >
            Create Your First Schedule
          </button>
        </div>
      ) : (
        <div className="space-y-4">
          {schedules.map((schedule) => (
            <div 
              key={schedule.id} 
              className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <h2 className="text-xl font-semibold text-gray-800 mb-2">
                    {schedule.name || 'Untitled Schedule'}
                  </h2>
                  <div className="space-y-1 text-sm text-gray-600">
                    <p>
                      <span className="font-medium">Created:</span> {formatDate(schedule.createdAt)}
                    </p>
                    <p>
                      <span className="font-medium">Created by:</span> {schedule.createdBy}
                    </p>
                    {schedule.updatedAt && schedule.updatedAt !== schedule.createdAt && (
                      <p>
                        <span className="font-medium">Last updated:</span> {formatDate(schedule.updatedAt)}
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex gap-3">
                  <button 
                    onClick={() => handleViewRota(schedule.id)}
                    className="btn-primary text-sm px-4 py-2"
                  >
                    View
                  </button>
                  <div className="relative">
                    <button 
                      onClick={() => handleDeleteRota(schedule.id)}
                      className="btn-danger text-sm px-4 py-2"
                    >
                      Delete
                    </button>
                    {confirmDelete === schedule.id && (
                      <div className="absolute top-full right-0 mt-2 bg-white border border-gray-300 rounded-lg shadow-lg p-4 z-10 w-64">
                        <p className="text-gray-700 mb-3">
                          Are you sure you want to delete "{schedule.name || 'Untitled Schedule'}"?
                        </p>
                        <div className="flex gap-2">
                          <button 
                            onClick={confirmDeleteRota} 
                            className="btn-danger text-sm px-3 py-1"
                          >
                            Yes, Delete
                          </button>
                          <button 
                            onClick={() => setConfirmDelete(null)} 
                            className="btn-secondary text-sm px-3 py-1"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SchedulesPage;